var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorFileSizeLimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin LMS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1935 -4960C-1935 -4961.1 -1934.1 -4962 -1933 -4962H11844C11845.1 -4962 11846 -4961.1 11846 -4960V5116C11846 5117.1 11845.1 5118 11844 5118H-1933C-1934.1 5118 -1935 5117.1 -1935 5116V-4960Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1933 -4961H11844V-4963H-1933V-4961ZM11845 -4960V5116H11847V-4960H11845ZM11844 5117H-1933V5119H11844V5117ZM-1934 5116V-4960H-1936V5116H-1934ZM-1933 5117C-1933.55 5117 -1934 5116.55 -1934 5116H-1936C-1936 5117.66 -1934.66 5119 -1933 5119V5117ZM11845 5116C11845 5116.55 11844.6 5117 11844 5117V5119C11845.7 5119 11847 5117.66 11847 5116H11845ZM11844 -4961C11844.6 -4961 11845 -4960.55 11845 -4960H11847C11847 -4961.66 11845.7 -4963 11844 -4963V-4961ZM-1933 -4963C-1934.66 -4963 -1936 -4961.66 -1936 -4960H-1934C-1934 -4960.55 -1933.55 -4961 -1933 -4961V-4963Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Upload Content"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    transform: "translate(-144 -482)",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Course Info",
    filter: "url(#filter0_d_2755_11825)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -56,
    y: -317.5,
    width: 815,
    height: 649,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lesson Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lesson"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.466,
    y: -172.966,
    width: 781.932,
    height: 225.252,
    rx: 3.73801,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.466,
    y: -172.966,
    width: 781.932,
    height: 225.252,
    rx: 3.73801,
    stroke: "#B2B2B3",
    strokeWidth: 1.068
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7277"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -157.5,
    width: 174,
    height: 194.32,
    rx: 8,
    fill: "#28519E",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: -27.5,
    y: -157,
    width: 173,
    height: 193.32,
    rx: 7.5,
    stroke: "#2572CC",
    strokeOpacity: 0.7,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Alert-Box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -7.99597,
    width: 142,
    height: 28.816,
    rx: 4,
    fill: "#DBDBDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.40802 0.00402832C2.87079 0.00402832 0 2.87482 0 6.41205C0 9.94927 2.87079 12.8201 6.40802 12.8201C9.94524 12.8201 12.816 9.94927 12.816 6.41205C12.816 2.87482 9.94524 0.00402832 6.40802 0.00402832ZM7.04882 9.61606H5.76722V5.77125H7.04882V9.61606ZM7.04882 4.48964H5.76722V3.20804H7.04882V4.48964Z",
    fill: "black"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2755_11825",
    x: -76,
    y: -333.5,
    width: 855,
    height: 689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.158125 0 0 0 0 0.203077 0 0 0 0 0.2875 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2755_11825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2755_11825",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorFileSizeLimit);
export default __webpack_public_path__ + "static/media/VectorFileSizeLimit.d0faec223be9c17064d6dc559181cbee.svg";
export { ForwardRef as ReactComponent };